import React from "react";
import "./Sidebar.css";
import Image from "react-bootstrap/Image";
import { useLocation, NavLink } from "react-router-dom";

function AppSidebar({ isOpen, toggleSidebar }) {
    const location = useLocation();
    const isActive = (path) => (location.pathname === path ? "active-page" : "");

    // Collapse sidebar on menu click (only for mobile)
    const handleMenuClick = () => {
        if (window.innerWidth <= 768) {
            // Delay slightly to allow navigation to complete smoothly
            setTimeout(() => {
                toggleSidebar();
            }, 200);
        }
    };

    return (
        <div className={`app-sidebar ${isOpen ? "open" : ""}`}>
            <div className="sidebar-header">
                <div className={`logo text-center ${isOpen ? "hidden-sidebar-logo" : ""}`}>
                    <Image
                        src="../images/logo-light.png"
                        width={150}
                        className="img-fluid mx-auto d-block"
                    />
                </div>
                <button className="close-btn" onClick={toggleSidebar}>
                    &times;
                </button>
            </div>

            <div className="app-menu">
                <ul className="accordion-menu">
                    <li className="sidebar-title">Menu</li>

                    <li className={isActive("/PatientApp/Dashboard")}>
                        <NavLink to="/PatientApp/Dashboard" onClick={handleMenuClick}>
                            <i className="fa-solid fa-gauge" />
                            Dashboard
                        </NavLink>
                    </li>

                    <li className={isActive("/PatientApp/Profile")}>
                        <NavLink to="/PatientApp/Profile" onClick={handleMenuClick}>
                            <i className="fa-solid fa-user" />
                            Profile
                        </NavLink>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default AppSidebar;
